// src/plugins/storeCachePlugin.ts
import { App } from 'vue'
import Dexie from 'dexie'

export interface CacheEntry {
  id: string
  store: string
  type: 'item' | 'collection' | 'draft' | string
  key: string
  value: string
  updatedAt: number
  ttl: number
}

class StoreCachePlugin extends Dexie {
  cache!: Dexie.Table<CacheEntry, string>

  constructor() {
    super('StoreCacheDB')
    this.version(1).stores({
      cache: '&id, store, type, key, updatedAt'
    })
  }
}

export function getTTLForStore(store: string): number {
  store = store.replace(/-store.gen$/, '').trim()
  if (!StoreCacheTTL[store]) console.log(`Missing TTL for object [${store}] in storeCachePlugin.ts - falling back to default: ${StoreCacheTTL['*']}`)
  return StoreCacheTTL[store] ?? StoreCacheTTL['*']
}

export const cacheDB = new StoreCachePlugin()

// zentrales TTL-Config (kann zur Laufzeit ersetzt werden)
export const StoreCacheTTL: Record<string, number> = {
  // z.B. 'employee': 300_000
  '*': 59_000,
  activity: 0,
  effort: 120_000,
  'planner-entry': 120_000,
  'effort-channel': 300_000,
  'time-tracking-stamp': 300_000,
  'business-partner': 600_000,
  'effort-type': 600_000,
  'service-type': 600_000,
  'expense-type': 600_000,
  'employee-skill': 60_000,
  'effort-member': 600_000,
  'worktime-tracking-day-version': 600_000,
  'effort-note': 600_000,
  department: 600_000,
  'cron-job-log': 600_000,
  'employee-avatar': 600_000,
  'effort-state': 600_000,
  'employee-config': 30_000,
  'sync-object': 15_000,
  'improvement-scope': 600_000,
  'improvement-topic': 60_000,
  improvement: 300_000,
  'employee-notification': 120_000,
  config: 300_000,
  'cms-page': 300_000,
  role: 600_000,
  'employee-state': 600_000,
  'worktime-tracking-day': 300_000,
  'employee-favorite': 60_000,
  'time-tracking': 120_000,
  'infoboard-entry': 300_000,
  employee: 300_000,
  'infoboard-entry-user-meta': 600_000,
  'effort-entry': 180_000,
  'feature-flag': 300_000
}

export default {
  async install(app: App) {
    await cacheDB.open()

    // Plugin-Marker (optional)
    app.config.globalProperties.$storeCacheReady = true
    // Bei Bedarf kann man hier preloaden oder Debug einbauen
  }
}
